import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartLine12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconChartLine12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M4.916 4.223a.5.5 0 0 0-.863.053l-2 4a.5.5 0 1 0 .894.448l1.615-3.23 1.522 2.283a.5.5 0 0 0 .89-.119l1.618-4.855 1.46 2.92a.5.5 0 1 0 .895-.447l-2-4a.5.5 0 0 0-.922.066L6.35 6.372zM.5 10a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1z"
            />
        </svg>
    );
}
export default memo(IconChartLine12);
